module.exports = __webpack_public_path__ + "media/svg-new/Angry-a0651c7d.svg";